
































import Vue from "vue";
import { format } from "@/utils/memoryFormat";
export default Vue.extend({
  name: "UsageCard",
  props: {
    title: { type: String },
    data: { type: Object },
    desc: { type: String }
  },
  methods: {
    percentage() {
      return this.data.used
        ? this.data.used / this.data.max > 1
          ? 100
          : parseFloat(((this.data.used * 100) / this.data.max).toFixed(2))
        : 0;
    },
    maxText() {
      if (this.desc == "内存") {
        return format(this.data.max);
      } else {
        return this.data.max;
      }
    },
    usedText() {
      if (this.desc == "内存") {
        return format(this.data.used);
      } else {
        return this.data.used.toFixed(2);
      }
    }
  },
  data() {
    return {
      statusColors: [
        { color: "#23b065", percentage: 30 },
        { color: "#f0c000", percentage: 60 },
        { color: "#f14c47", percentage: 90 }
      ]
    };
  }
});
